import { render } from "./ProjectsGrid.vue?vue&type=template&id=40521625&scoped=true"
import script from "./ProjectsGrid.vue?vue&type=script&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&lang=js"

import "./ProjectsGrid.vue?vue&type=style&index=0&id=40521625&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40521625"]])

export default __exports__